import { Registry, BaseItem, Vec2, Vec3, Vec4, Color, RGBA, Quat, Xfo, Mat3, Mat4 } from '@zeainc/zea-engine'

const convertValuesToJSON = (value) => {
  if (value == undefined) {
    return undefined
  } else if (value instanceof BaseItem) {
    return '::' + value.getPath().join('/')
  } else if (value.toJSON) {
    const result = value.toJSON()
    if (value.getClassName) result.typeName = value.getClassName()
    else if (value instanceof Vec2) result.typeName = 'Vec2'
    else if (value instanceof Vec3) result.typeName = 'Vec3'
    else if (value instanceof Vec4) result.typeName = 'Vec4'
    else if (value instanceof Color) result.typeName = 'Color'
    else if (value instanceof RGBA) result.typeName = 'RGBA'
    else if (value instanceof Quat) result.typeName = 'Quat'
    else if (value instanceof Xfo) result.typeName = 'Xfo'
    else if (value instanceof Mat3) result.typeName = 'Mat3'
    else if (value instanceof Mat4) result.typeName = 'Mat4'
    else {
      console.warn('Unhandled type conversion to JSON:', value)
    }
    return result
  } else if (Array.isArray(value)) {
    const arr = []
    for (const element of value) arr.push(convertValuesToJSON(element))
    return arr
  } else if (typeof value === 'object') {
    const dict = {}
    for (const key in value) dict[key] = convertValuesToJSON(value[key])
    return dict
  } else {
    return value
  }
}

const convertValuesFromJSON = (value, scene) => {
  if (value == undefined) {
    return undefined
  } else if (typeof value === 'string' && value.startsWith('::')) {
    const path = value.split('/')
    return scene.getRoot().resolvePath(path, 1)
  } else if (value.typeName) {
    let newVal
    if (value.typeName == 'Vec2') newVal = new Vec2()
    else if (value.typeName == 'Vec3') newVal = new Vec3()
    else if (value.typeName == 'Vec4') newVal = new Vec4()
    else if (value.typeName == 'Color') newVal = new Color()
    else if (value.typeName == 'RGBA') newVal = new RGBA()
    else if (value.typeName == 'Quat') newVal = new Quat()
    else if (value.typeName == 'Xfo') newVal = new Xfo()
    else if (value.typeName == 'Mat3') newVal = new Mat3()
    else if (value.typeName == 'Mat4') newVal = new Mat4()
    else {
      try {
        newVal = Registry.constructClass(value.typeName)
      } catch (error) {
        console.warn('Unhandled type conversion from JSON:', value.typeName)
        return undefined
      }
    }
    newVal.fromJSON(value)
    return newVal
  } else if (Array.isArray(value)) {
    const arr = []
    for (const element of value) arr.push(convertValuesFromJSON(element, scene))
    return arr
  } else if (typeof value === 'object') {
    const dict = {}
    for (const key in value) dict[key] = convertValuesFromJSON(value[key], scene)
    return dict
  } else {
    return value
  }
}

export { convertValuesToJSON, convertValuesFromJSON }
